import React, { Component } from "react";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { view } from '@risingstack/react-easy-state';
import { Grid } from "@material-ui/core";
import NumberField from "./NumberField";
import EditFieldState from "../../../State/EditFieldState";

const possibleValidators = [{
    field: "minAmount",
    label: "Field has a minimum value",
    options: [{
        field: "minimumAmountValue",
        label: "Minimum amount",
        type: "int",
        defaultValue: 1,
        errorText: "Minimum amount must be greater than 0"
    }]
}];

const regExTypes = [""];

class AmountValidatorField extends Component {

    handleFieldChange(field, value, event, validation_disabled = false, regEx = false) {
        
        if(typeof value === 'number' && Number(value) < 0) {
            EditFieldState.isError = true;            
        } else {
            EditFieldState.isError = false;
        }
        if (validation_disabled) {
            event.preventDefault();
            event.stopPropagation();
        }
        else {
            const values = this.props.value ? { ...this.props.value } : {}
            regExTypes.forEach(type => {
                if (values.hasOwnProperty(type) && regEx) {
                    values[type] = false;
                }
            });

            values[field] = value;
            this.props.onChange(values);
        }
    }

    getValue(field) {
        if (this.props.value) {
            if (typeof this.props.value[field] === "undefined") {
                if (typeof this.props.option.defaultValues[field] === "undefined") {
                    return false;
                } else {
                    this.handleFieldChange(field, this.props.option.defaultValues[field]);
                    return this.props.option.defaultValues[field]
                }
            } else {
                return this.props.value[field];
            }
        } else {
            if (typeof this.props.option.defaultValues[field] === "undefined") {
                return false;
            } else {
                this.handleFieldChange(field, this.props.option.defaultValues[field]);
                return this.props.option.defaultValues[field]
            }
        }
    }

    renderField(validator, key) {
        
        return (
            <Grid container key={key}>
                <Grid xs={12}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                name={validator.field}
                                checked={this.getValue(validator.field)}
                                onChange={(event) => this.handleFieldChange(validator.field, event.target.checked, event, this.props.option.disabledFields.includes(validator.field) ? true : false, regExTypes.includes(validator.field) ? true : false)}
                                color="primary"
                                className={this.props.option.disabledFields.includes(validator.field) ? "validation-disabled" : ""}
                            />
                        }
                        label={validator.label}
                        className={this.props.option.disabledFields.includes(validator.field) ? "validation-disabled" : ""}
                    />
                    {validator.options && this.getValue(validator.field) === true && validator.options.map((subField, subIndex) => (
                        <div key={subIndex}>
                            {subField.type === "int" && <NumberField
                                value={this.getValue(subField.field || subField.defaultValue)}
                                defaultValue={subField.defaultValue}
                                onChange={(value) => { this.handleFieldChange(subField.field, value) }}
                                label={subField.label}
                                type={"Number"}
                                error={EditFieldState.isError}
                                helperText={EditFieldState.isError ? subField.errorText : ""}
                            />}
                        </div>
                    ))}
                </Grid>
            </Grid>
        );
    }

    render() {
        return (
            <>
                {possibleValidators.map((validator, index) => this.renderField(validator, index))}
            </>
        );
    }

}

export default view(AmountValidatorField);